<template>
	<div v-if="toedit.setting">
		<div v-if="toedit.hasChildren > 1" :key="useless + '' + totalCol + 'main'">
			<div style="padding-right: 15px; width: 100%; display: flex">
				<h4>{{ $t("column-dimension") }}</h4>
				<how-to-use>
					<div v-html="$t('how-to-use-column')"></div>
				</how-to-use>
			</div>

			<p :key="useless + '' + totalCol + 'main2'">
				{{ $t("column-number") }}:
				<span style="font-weight: 700">{{ toedit.setting.column_width.length }} </span> -
				{{ $t("used-space-column") }}:
				<span
					:key="useless + '' + totalCol + 'main3'"
					style="font-weight: 500"
					:style="{ color: totalCol.substr(0, totalCol.length - 1) > 100 ? '#f44336' : 'black' }"
				>
					{{ totalCol }}</span
				>
			</p>

			<div style="width: 100%; display: flex">
				<div
					v-for="(el, idx) in toedit.setting.column_width"
					:key="toedit.setting.column_width[idx] + '%' + idx + useless"
					style="border: 1pt solid black"
					:style="{ width: toedit.setting.column_width[idx] + '%' }"
				>
					<input
						@change="
							useless++
							updateProp()
						"
						v-model="toedit.setting.column_width[idx]"
						type="number"
					/>
				</div>
			</div>
		</div>

		<div style="display: flex; flex-wrap: wrap">
			<!-- WIDTH -->
			<div style="display: flex; width: 100%">
				<div style="padding-right: 15px; width: 20%; display: flex">
					<h4>{{ $t("width") }}:</h4>
					<how-to-use>
						<div v-html="$t('how-to-use-width')"></div>
					</how-to-use>
				</div>
				<div style="display: flex; align-items: center; width: 20%">
					<el-radio @change="updateProp()" v-model="widthType" label="%">%</el-radio>
					<el-radio @change="updateProp()" v-model="widthType" label="auto">Auto</el-radio>
					<el-radio @change="updateProp()" v-model="widthType" label="px">Pixel</el-radio>
				</div>
				<div style="flex: 1; padding: 0 15px" v-if="widthType !== undefined">
					<div v-if="widthType === '%'">
						<el-slider @change="updateProp()" v-model="widthValue"></el-slider>
					</div>
					<div v-if="widthType === 'px'" style="display: flex">
						<el-input-number
							@change="updateProp()"
							v-model="widthValue"
							style="width: 30%; border: 1pt solid #ccc; border-radius: 5px"
						></el-input-number>
						<span style="display: flex; align-items: center; margin-left: 10px">px</span>
					</div>
				</div>
			</div>
			<!-- HEIGHT -->
			<div style="display: flex; width: 100%; margin: 10px 0">
				<div style="padding-right: 15px; width: 20%; display: flex">
					<h4>{{ $t("height") }}:</h4>
					<how-to-use>
						<div v-html="$t('how-to-use-height')"></div>
					</how-to-use>
				</div>
				<div style="display: flex; align-items: center; width: 20%">
					<el-radio @change="updateProp()" v-model="heightType" label="%">%</el-radio>
					<el-radio @change="updateProp()" v-model="heightType" label="auto">Auto</el-radio>
					<el-radio @change="updateProp()" v-model="heightType" label="px">Pixel</el-radio>
				</div>
				<div style="padding: 0 15px; flex: 1" v-if="heightType !== undefined">
					<div v-if="heightType === '%'">
						<el-slider @change="updateProp()" v-model="heightValue"></el-slider>
					</div>
					<div v-if="heightType === 'px'" style="display: flex">
						<el-input-number
							@change="updateProp()"
							v-model="heightValue"
							style="width: 30%; border: 1pt solid #ccc; border-radius: 5px"
						></el-input-number>
						<span style="display: flex; align-items: center; margin-left: 10px">px</span>
					</div>
				</div>
			</div>
			<!-- SFONDO -->
			<div style="display: flex; width: 100%">
				<div style="padding-right: 15px; display: flex">
					<h4>{{ $t("background-color") }}:</h4>
					<how-to-use>
						<div v-html="$t('how-to-use-background')"></div>
					</how-to-use>
				</div>
				<div>
					<el-color-picker
						@change="updateProp()"
						style="display: inline-block; margin: auto"
						show-alpha
						v-model="toedit.setting.sfondo"
					></el-color-picker>
				</div>
			</div>
			<!-- BOTTOM SECTION -->
			<div style="width: 100%; display: flex">
				<!-- PADDING & ALIGN -->
				<div style="width: 40%; padding: 5px">
					<!-- TOP -->
					<how-to-use>
						<div v-html="$t('how-to-use-padding')"></div>
					</how-to-use>

					<div style="width: 100%; display: flex; justify-content: center">
						<el-input
							@change="updateProp()"
							v-model="topMargin"
							style="width: 30%; border: 1pt solid #ccc"
						></el-input>
					</div>
					<!-- SX ALIGN DX -->
					<div style="width: 100%; display: flex">
						<el-input
							@change="updateProp()"
							v-model="leftMargin"
							style="width: 30%; border: 1pt solid #ccc"
						></el-input>

						<div>
							<el-select @change="updateProp()" v-model="toedit.setting.align" placeholder="Select">
								<el-option
									v-for="item in selectOptions"
									:key="item.value"
									:label="item.label"
									:value="item.value"
									:disabled="item.disabled"
								>
								</el-option>
							</el-select>
						</div>

						<el-input
							@change="updateProp()"
							v-model="rightMargin"
							style="width: 30%; border: 1pt solid #ccc"
						></el-input>
					</div>
					<!-- BOTTOM -->
					<div style="width: 100%; display: flex; justify-content: center">
						<el-input
							@change="updateProp()"
							v-model="bottomMargin"
							style="width: 30%; border: 1pt solid #ccc"
						></el-input>
					</div>
				</div>
				<!-- PREVIEW -->
				<div
					style="border: 1pt solid black; flex: 1; display: flex; border-radius: 5px"
					:style="{ 'justify-content': toedit.setting.align, 'background-color': toedit.setting.sfondo }"
				>
					<div
						style="
							width: 50px;
							height: 50px;
							display: flex;
							border: 1pt solid #232323;
							background-color: #fff;
							border-radius: 5px;
						"
						:style="{
							'margin-top': toedit.setting.padding.split(' ')[0],
							'margin-right': toedit.setting.padding.split(' ')[1],
							'margin-bottom': toedit.setting.padding.split(' ')[2],
							'margin-left': toedit.setting.padding.split(' ')[3]
						}"
					></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex"
import HowToUse from "@/modules/builder/components/how-to-use"
export default {
	name: "css-modal",
	//   props: ["toeditIN"],
	components: {
		HowToUse
	},
	data() {
		return {
			useless: 0,
			widthType: "auto",
			heightType: "auto",
			widthValue: 0,
			heightValue: 0
		}
	},
	created() {
		// this.toedit=this.toeditIN

		if (this.toedit.setting.width[this.toedit.setting.width.length - 1] === "%") {
			this.widthType = "%"
			this.widthValue = Number(this.toedit.setting.width.substr(0, this.toedit.setting.width.length - 1))
		} else if (this.toedit.setting.width[this.toedit.setting.width.length - 1] === "x") {
			this.widthType = "px"
			this.widthValue = this.toedit.setting.width.substr(0, this.toedit.setting.width.length - 2)
		} else {
			this.widthType = "auto"
			this.widthValue = 0
		}

		if (this.toedit.setting.height[this.toedit.setting.height.length - 1] === "%") {
			this.heightType = "%"
			this.heightValue = Number(this.toedit.setting.height.substr(0, this.toedit.setting.height.length - 1))
		} else if (this.toedit.setting.height[this.toedit.setting.height.length - 1] === "x") {
			this.heightType = "px"
			this.heightValue = this.toedit.setting.height.substr(0, this.toedit.setting.height.length - 2)
		} else {
			this.heightType = "auto"
			this.heightValue = 0
		}
	},
	computed: {
		totalCol: function () {
			let a = this.useless
			const m = this.toedit.setting.column_width.map(i => Number(i))
			const s = m.reduce((a, b) => a + b, 0)
			this.updateProp()
			return s + "%"
		},

		topMargin: {
			get() {
				if (this.toedit) {
					return this.toedit.setting.padding.split(" ")[0]
				} else {
					return 0
				}
			},
			set(el) {
				if (this.toedit) {
					let temp = el
					let numb = temp.match(/\d/g)
					if (numb) numb = numb.join("")
					temp = numb + "px"
					el = temp
					if (el === "nullpx") el = "0"
					var arr = this.toedit.setting.padding.split(" ")
					arr[0] = el
					this.toedit.setting.padding = arr.join(" ")
					this.updateProp()
				}
			}
		},
		rightMargin: {
			get() {
				if (this.toedit) {
					return this.toedit.setting.padding.split(" ")[1]
				} else {
					return 0
				}
			},
			set(el) {
				if (this.toedit) {
					let temp = el
					let numb = temp.match(/\d/g)
					if (numb) numb = numb.join("")
					temp = numb + "px"
					el = temp
					if (el === "nullpx") el = "0"
					var arr = this.toedit.setting.padding.split(" ")
					arr[1] = el
					this.toedit.setting.padding = arr.join(" ")
					this.updateProp()
				}
			}
		},
		bottomMargin: {
			get() {
				if (this.toedit) {
					return this.toedit.setting.padding.split(" ")[2]
				} else {
					return 0
				}
			},
			set(el) {
				if (this.toedit) {
					let temp = el
					let numb = temp.match(/\d/g)
					if (numb) numb = numb.join("")
					temp = numb + "px"
					el = temp
					if (el === "nullpx") el = "0"
					var arr = this.toedit.setting.padding.split(" ")
					arr[2] = el
					this.toedit.setting.padding = arr.join(" ")
					this.updateProp()
				}
			}
		},
		leftMargin: {
			get() {
				if (this.toedit) {
					return this.toedit.setting.padding.split(" ")[3]
				} else {
					return 0
				}
			},
			set(el) {
				if (this.toedit) {
					let temp = el
					let numb = temp.match(/\d/g)
					if (numb) numb = numb.join("")
					temp = numb + "px"
					el = temp
					if (el === "nullpx") el = "0"
					var arr = this.toedit.setting.padding.split(" ")
					arr[3] = el
					this.toedit.setting.padding = arr.join(" ")
					this.updateProp()
				}
			}
		},
		showEdit: {
			get() {
				if (this.showEdit_state) {
					if (this.toedit.setting.width[this.toedit.setting.width.length - 1] === "%") {
						this.widthType = "%"
						this.widthValue = Number(
							this.toedit.setting.width.substr(0, this.toedit.setting.width.length - 1)
						)
					} else if (this.toedit.setting.width[this.toedit.setting.width.length - 1] === "x") {
						this.widthType = "px"
						this.widthValue = this.toedit.setting.width.substr(0, this.toedit.setting.width.length - 2)
					} else {
						this.widthType = "auto"
						this.widthValue = ""
					}

					if (this.toedit.setting.height[this.toedit.setting.height.length - 1] === "%") {
						this.heightType = "%"
						this.heightValue = Number(
							this.toedit.setting.height.substr(0, this.toedit.setting.height.length - 1)
						)
					} else if (this.toedit.setting.height[this.toedit.setting.height.length - 1] === "x") {
						this.heightType = "px"
						this.heightValue = this.toedit.setting.height.substr(0, this.toedit.setting.height.length - 2)
					} else {
						this.heightType = "auto"
						this.heightValue = ""
					}
				}

				return this.showEdit_state
			},
			set(el) {
				if (el) {
					this.show_edit()
				} else {
					this.hide_edit()
				}
			}
		},
		...mapGetters({
			nodes: "flowchart/nodes",
			toinsert: "builder/toinsert",
			toedit: "builder/toedit",
			showInsert: "builder/showInsert",
			showEdit_state: "builder/showEdit",
			selectOptions: "builder/selectOptions",
			node_value_builder: "flowchart/node_value_builder",
			selected_node_id: "flowchart/showModalEdit",
			node_value: "flowchart/node_value",
			cut: "builder/cut"
		})
	},
	methods: {
		...mapActions({
			addElement: "builder/addElement",
			editInsert: "builder/editInsert",
			editEdit: "builder/editEdit",
			showModalInsert: "builder/showModalInsert",
			hideModalInsert: "builder/hideModalInsert",
			hideModalEdit: "builder/hideModalEdit",
			showModalEdit: "builder/showModalEdit",
			editNodeValue: "flowchart/editNodeValue",
			editModalEdit: "flowchart/editModalEdit",
			setCut: "builder/setCut",
			resetCut: "builder/resetCut"
		}),
		...mapMutations({
			show_edit: "builder/SHOW_EDIT",
			hide_edit: "builder/HIDE_EDIT"
		}),

		updateProp() {
			//  this.editEdit( this.toedit)
		}
	},
	watch: {
		widthType: function (el) {
			if (el === "%" && this.widthValue.length === 0) this.widthValue = 0
			this.widthType === "auto"
				? (this.toedit.setting.width = "auto")
				: (this.toedit.setting.width = this.widthValue + el)
			if (this.widthType === "auto") this.widthValue = 0
		},
		heightType: function (el) {
			if (el === "%" && this.heightValue.length === 0) this.heightValue = 0
			this.heightType === "auto"
				? (this.toedit.setting.height = "auto")
				: (this.toedit.setting.height = this.heightValue + el)
			if (this.heightType === "auto") this.heightValue = 0
		},
		widthValue: function (el) {
			this.toedit.setting.width = el + this.widthType
		},
		heightValue: function (el) {
			this.toedit.setting.height = el + this.heightType
		}
	}
}
</script>

<style scoped></style>
